import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ToolsService } from 'src/app/services/tools.service';
import { ConfigService } from 'src/app/services/config.service';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-modal-add-address',
  templateUrl: './modal-add-address.page.html',
  styleUrls: ['./modal-add-address.page.scss'],
})
export class ModalAddAddressPage implements OnInit {
  addressQuestions: any;

  constructor(
    public toolsService: ToolsService,
    public configService: ConfigService,
    public modalController: ModalController, 
    private analyticsService: AnalyticsService
  ) { 
    this.analyticsService.AnalyticsServiceModalView('add-address');
    this.loadForm();
  }

  ngOnInit() {
  }


  //Function to load address form 
  loadForm(){
    this.addressQuestions = [
      { label: 'Nombre destinatario', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required]) },
      { label: 'Celular destinatario', format: 'input', type: 'number', formControl: new FormControl('', [Validators.required, Validators.maxLength(13)])},
      { label: 'Documento destinatario', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required]) },
      { label: 'Dirección', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required]) },
      { label: 'Ciudad', format: 'autocomplete', type: 'text', search_url: '/crm/get_cities', formControl: new FormControl('', [Validators.required]) },
      { label: 'Barrio', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required]) },
      { label: 'Información adicional dirección', placeholder: 'Casa azul, por favor golpear', format: 'input', type: 'text', formControl: new FormControl('')},
    ]
  }

  //Function to add address
  async addAddress(){
    if(this.toolsService.validateQuestions(this.addressQuestions)){
      await this.toolsService.showLoader();
      try{
        var city = this.addressQuestions[4].formControl.value
        var addressCreated = {
          info: this.addressQuestions[3].formControl.value,
          servientrega_city: {
            city: {
              id: city.value,
              name: city.name
            }
          },
          neighborhood: this.addressQuestions[5].formControl.value,
          additional_info: this.addressQuestions[6].formControl.value,
          person_name: this.addressQuestions[0].formControl.value,
          cellphone: this.addressQuestions[1].formControl.value,
          document: this.addressQuestions[2].formControl.value,
          is_active: true
        }
        var address = await this.configService.addAddress(addressCreated);
        addressCreated['id'] = address.id
        this.toolsService.showSuccessToast('Dirección agregada correctamente');
        this.modalController.dismiss(addressCreated)
      }catch(error){
        this.toolsService.showErrorToast();
        console.error('[MODAL-ADD-ADDRESS-PAGE] addAddress()', error);
      }
      await this.toolsService.dismissLoader();
    }else{
      this.toolsService.markAsTouched(this.addressQuestions)
    }
  }

  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }
}
